import { Info } from '@hendrx/icons/Info';
import { Box, Flex, Switch, Title, Tooltip } from '@mantine/core';
import cx from 'clsx';
import { ReactNode } from 'react';

import classes from './FormSection.module.scss';

type FormSectionProps = {
  label?: string;
  info?: string;
  extraHeaderStartData?: ReactNode;
  extraHeaderEndData?: ReactNode;
  children: ReactNode;
  withToggle?: boolean;
  checked?: boolean;
  onCheck?: (value: boolean) => void;
  withDivider?: boolean;
  withPadding?: boolean;
  withHeaderPadding?: boolean;
  withoutHeaderPadding?: boolean;
  withAsterisk?: boolean;
};

export function FormSection(props: FormSectionProps) {
  const {
    children,
    label,
    withToggle,
    info,
    extraHeaderStartData,
    extraHeaderEndData,
    checked,
    onCheck,
    withDivider,
    withPadding,
    withHeaderPadding,
    withoutHeaderPadding,
    withAsterisk
  } = props;

  return (
    <Box className={cx(classes.sectionWrapper, withDivider ? classes.withDivider : '')}>
      <Flex
        align="center"
        justify="space-between"
        className={cx(
          classes.sectionHeader,
          (withPadding || withHeaderPadding) && classes.headerPadding,
          withoutHeaderPadding && classes.withoutHeaderPadding
        )}
      >
        {(label || extraHeaderStartData) && (
          <Flex gap={2}>
            {label && <Title order={5}>{label}</Title>}
            {withAsterisk && (
              <Box component="span" className={classes.asterisk}>
                *
              </Box>
            )}
            {extraHeaderStartData}
          </Flex>
        )}
        {info && (
          <Tooltip label={info} multiline withArrow className={classes.infoTooltip}>
            <Info className={classes.infoIcon} />
          </Tooltip>
        )}
        {withToggle && <Switch checked={checked} onChange={event => onCheck?.(event.currentTarget.checked)} />}
        {extraHeaderEndData}
      </Flex>
      {(!withToggle || checked) && <Box className={withPadding ? classes.contentPadding : undefined}>{children}</Box>}
    </Box>
  );
}
